export const GOOGLE_CLIENT_ID =
  '246048455132-ci0m321e2ncde3ke6ojak531i30qal6t.apps.googleusercontent.com'
